import setup from "./setup";
var track = function track() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return setup().then(function () {
    var _window$analytics;
    (_window$analytics = window.analytics).track.apply(_window$analytics, args);
    console.log("%c @analytics/segment - track", "color: #bada55", args);
  });
};
var identity = function identity() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return setup().then(function () {
    var _window$analytics2;
    (_window$analytics2 = window.analytics).identify.apply(_window$analytics2, args);
    console.log("%c @analytics/segment - identity", "color: #bada55", args);
  });
};
var page = function page() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  return setup().then(function () {
    var _window$analytics3;
    (_window$analytics3 = window.analytics).page.apply(_window$analytics3, args);
    console.log("%c @analytics/segment - page view", "color: #bada55", args);
  });
};
export default {
  track: track,
  identity: identity,
  page: page
};